import { BaseModel, BelongsTo, Attribute } from './base-model'
import { Video } from './video'

export class Lecture extends BaseModel {
  public id: number
  public name: string
  @Attribute(Date) public date: Date
  @Attribute(Date) public startedAt: Date
  @Attribute(Date) public endedAt: Date
  public children: Lecture[]
}



// WEBPACK FOOTER //
// ./src/models/lecture.ts